module.exports = __webpack_public_path__ + "media/images/new_landing/people/karolina-matejova-5e343bed27234589ae66538f1a81840f.jpeg";